class AnnouncementBar extends HTMLElement {

  async connectedCallback() {
    await customElements.whenDefined("announcement-bar-item");
    this.items = Array.from(this.querySelectorAll("announcement-bar-item"));
    this.hasPendingTransition = false;
    this._startPlayer();
  }

  get selectedIndex() {
    return this.items.findIndex(item => item.selected);
  }

  next() {
    this.select((this.selectedIndex + 1) % this.items.length);
  }

  async select(index, animate = true) {
    if (this.selectedIndex === index || this.hasPendingTransition) {
      return;
    }
    this._pausePlayer();
    this.hasPendingTransition = true;
    await this.items[this.selectedIndex].deselect(animate);
    await this.items[index].select(animate);
    this.style.backgroundColor = this.items[index].style.backgroundColor;
    this.hasPendingTransition = false;
    this._startPlayer();
  }

  _pausePlayer() {
    clearInterval(this._interval);
  }

  _startPlayer() {
    const cycleSpeed = parseInt(this.getAttribute("cycle-speed")) * 1000;
    this._interval = setInterval(this.next.bind(this), cycleSpeed);
  }
}

window.customElements.define("announcement-bar", AnnouncementBar);

class AnnouncementBarItem extends HTMLElement {
  get index() {
    return [...this.parentNode.children].indexOf(this);
  }

  get hasContent() {
    return this.hasAttribute("has-content");
  }

  get selected() {
    return !this.hasAttribute("hidden");
  }

  async select(animate = true) {
    this.removeAttribute("hidden");

    await new Promise(resolve => {
      const animation = this.animate(
        {
          transform: ["translateY(10px)", "translateY(0)"],
          opacity: [0, 1]
        },
        {
          duration: animate ? 250 : 0,
          easing: "ease-in-out"
        }
      );
      animation.onfinish = resolve;
    });
  }

  async deselect(animate = true) {
    await this.closeContent();

    await new Promise(resolve => {
      const animation = this.animate(
        {
          transform: ["translateY(0)", "translateY(-10px)"],
          opacity: [1, 0]
        },
        {
          duration: animate ? 150 : 0,
          easing: "ease-in-out"
        }
      );
      animation.onfinish = resolve;
    });

    this.setAttribute("hidden", "");
  }

  async closeContent() {
    if (!this.hasContent || this.contentElement.hasAttribute("hidden")) {
      return Promise.resolve();
    }

    await new Promise(resolve => {
      this.contentElement.addEventListener("transitionend", () => resolve(), {
        once: true
      });
      this.contentElement.setAttribute("hidden", "");
    });
  }
}
window.customElements.define("announcement-bar-item", AnnouncementBarItem);
